import {
  DATE_RANGE_NUMERIC_VALUES,
  generateDateMonthsPrevious,
} from 'components/Dashboard/Dashboard.context.helpers';
import { TApplication } from 'lendingApi/applications.types';
import { TAvailableProducts } from 'lendingApi/lendingApi.types';
import { TSupportedLocales } from 'types';
import { UK_LOCALE } from 'utils/i18n';
import { deriveProductFromTypeAndDuration } from 'utils/productHelper';
import { TAction, TApplicationTableState } from './ApplicationTable.types';

type NullableAvailableProduct = TAvailableProducts | undefined;
function reduceApplicationProductTypes(
  applications?: TApplication[],
  locale?: TSupportedLocales,
) {
  if (!applications) return [];
  const applicationProductTypes: Set<NullableAvailableProduct> = new Set([
    undefined,
  ]);

  for (const app of applications) {
    const productType = app.requested_products?.[0]
      ?.product_type as NullableAvailableProduct;
    const duration = app.requested_products?.[0]?.duration;

    const { type: derivedProductType } = deriveProductFromTypeAndDuration({
      productType,
      duration,
      isUK: locale === UK_LOCALE,
    });

    if (!derivedProductType) continue;

    applicationProductTypes.add(derivedProductType);
  }

  return Array.from(applicationProductTypes).sort();
}

function generateDateFromDateRange(dateRange: string | null) {
  const numberOfMonths = DATE_RANGE_NUMERIC_VALUES[dateRange || 'default'];
  return generateDateMonthsPrevious(numberOfMonths);
}

function reducer(state: TApplicationTableState, action: TAction) {
  switch (action.type) {
    case 'loading': {
      return {
        ...state,
        loading: true,
      };
    }
    case 'fetchedApplications': {
      return {
        ...state,
        applications: action.applications?.data,
        applicationProductTypes: reduceApplicationProductTypes(
          action.applications?.data,
          action.locale,
        ),
      };
    }
    case 'searchApplication': {
      return {
        ...state,
        searchString: action.searchString,
      };
    }
    case 'searchApplicationDateRange': {
      return {
        ...state,
        dateFrom: generateDateFromDateRange(action.dateFrom),
      };
    }
    case 'searchApplicationPartnerChannelToggle': {
      return {
        ...state,
        includePartnerChannel: action.includePartnerChannel,
      };
    }
    case 'error': {
      return {
        ...state,
        error: action.error,
      };
    }
  }
}

export default reducer;
